import { Grid, useTheme } from '@mui/material'
import React from 'react'
import { Icon } from 'packages/eid-icons'
import './workFlowItem.css'
import { useAppState } from 'appContext'
type props = {
    title: string
    description: string
    onClick: () => void
    isEnabled: any
}

const WorkFlowsItems: React.FC<props> = ({
    title,
    description,
    onClick,
    isEnabled,
}) => {
    const [{ appConfig }]: any = useAppState()
    const themeColors = appConfig.style?.colors
    const theme = useTheme()

    return (
        <Grid
            onClick={onClick}
            item
            md={4}
            xs={12}
            spacing={2}
            className={`workflowinnergrid ${
                isEnabled ? 'show-workflow' : 'disable-workflow'
            }`}
            data-ai-explain={`Workflow tile: ${title}`}
            data-ai-explain-section="listing"
            tabIndex={isEnabled ? 0 : -1}
            aria-disabled={!isEnabled}
            onKeyDown={(e) => {
                if (isEnabled && (e.key === 'Enter' || e.key === ' ')) {
                    e.preventDefault();
                    onClick();
                }
            }}
        >
            <div
                className={
                    themeColors?.gradient && themeColors?.secondaryGradient
                        ? 'dynamic-workflow-header'
                        : 'gridtitle'
                }
                style={
                    themeColors?.gradient && themeColors?.secondaryGradient
                        ? {
                              background: themeColors?.gradient,
                              color: theme?.palette?.common?.white,
                          }
                        : undefined
                }
                onMouseEnter={(e) => {
                    if (themeColors?.secondaryGradient) {
                        e.currentTarget.style.background =
                            themeColors.secondaryGradient
                        e.currentTarget.style.cursor = 'pointer'
                    }
                }}
                onMouseLeave={(e) => {
                    if (themeColors?.gradient) {
                        e.currentTarget.style.background = themeColors.gradient
                    }
                }}
            >
                <h2>{title}</h2>
            </div>
            <div className="workflowdescription inActive">
                <Icon name="WorkFlowChart" /> <p>{description}</p>
            </div>
            <div className="workflowdescription active">
                <Icon name="WorkFlowChartSelected" /> <p>{description}</p>
            </div>
        </Grid>
    )
}

export default WorkFlowsItems
